var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widgetTitle } },
    [
      _c("p"),
      _vm._v(" "),
      !_vm.isLoadingSettings
        ? _c("BuyerRegistrationSettingsForm", {
            attrs: { setting: _vm.brpSettings }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoadingSettings
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOADING_SETTINGS",
                    expression: "'LOADING_SETTINGS'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }